import Vue from 'vue';

export default Vue.component('upload-progress', {
  template: require('./template.html'),
  name: 'upload-progress',
  props: ['upload-list', 'added-classes'],
  methods: {
    abortUpload(upload) {
      if (upload.status === 'uploading') {
        upload.s3.abort();
      } else {
        this.$emit('remove-upload', upload.id);
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/mixins/aws/uploader/index.js